import { render, staticRenderFns } from "./CHPPRootLayout.vue?vue&type=template&id=1df3a102&"
import script from "./CHPPRootLayout.vue?vue&type=script&lang=ts&"
export * from "./CHPPRootLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports